import React from "react";
import { useSelector } from "react-redux";
import { Button } from "@/components/ui/button";
import { ArrowUpCircle, Gift } from "lucide-react";

const PlanActionButton = ({
  plan,
  isMember,
  isPlanProcessing,
  selectedPlanId,
  onSelectPlan,
  onLearnMore,
  frontendProps,
  trialEligible,
}) => {
  const user = useSelector((state) => state.auth.user);
  const membership = user?.membership;
  const userPlan = membership?.plan || "free";

  let buttonText = "";
  let buttonAction = () => onSelectPlan(plan.id, plan.name);
  let disableButton = isPlanProcessing || !!selectedPlanId;
  let buttonVariant = frontendProps.buttonVariant;
  let ButtonIcon = null;

  const isTrialActive = membership?.isTrial && !membership?.trialExpired;
  const isTrialExpiredUnacknowledged =
    membership?.trialExpired && !membership?.trialAcknowledged;

  if (isTrialActive && userPlan === plan.id) {
    buttonText = "Current Trial";
    buttonVariant = "success";
    disableButton = true;
  } else if (isTrialExpiredUnacknowledged) {
    if (plan.id === "free") {
      buttonText = "Acknowledge Trial End";
      buttonVariant = "outline";
      disableButton = true; // Modal forces action globally
    } else {
      buttonText = `Upgrade to ${plan.name}`;
      buttonVariant = "default";
      ButtonIcon = ArrowUpCircle;
    }
  } else if (userPlan === plan.id) {
    buttonText = "Active Plan";
    buttonVariant = "success";
    disableButton = true;
  } else if (trialEligible && plan.id !== "free" && isMember) {
    // Authenticated seller on free plan, never trialed — show Start Free Trial
    buttonText = "Start Free Trial";
    buttonVariant = "default";
    ButtonIcon = Gift;
  } else if (userPlan === "free") {
    if (plan.id === "free") {
      buttonText = "Active Plan";
      buttonVariant = "success";
      disableButton = true;
    } else {
      buttonText = `Upgrade to ${plan.name}`;
      buttonVariant = "default";
      ButtonIcon = ArrowUpCircle;
    }
  } else {
    if (plan.id === "free" || (userPlan === "premium" && plan.id === "pro")) {
      buttonText = "Downgrade";
      buttonVariant = "outline";
    } else {
      buttonText = `Upgrade to ${plan.name}`;
      buttonVariant = "default";
      ButtonIcon = ArrowUpCircle;
    }
  }

  // Guest / unauthenticated user — route to learn more / sign up
  if (!isMember && plan.id !== "free" && buttonText !== "Active Plan") {
    buttonAction = onLearnMore;
    if (trialEligible) {
      buttonText = "Start Free Trial";
      ButtonIcon = Gift;
    } else {
      buttonText = frontendProps.buttonTextDefault || buttonText;
      ButtonIcon = null;
    }
  }

  if (isPlanProcessing && selectedPlanId === plan.id) {
    buttonText = "Processing...";
    disableButton = true;
    ButtonIcon = null;
  }

  return (
    <Button
      className="w-full text-sm xs:text-base h-auto xs:h-11 py-2.5"
      variant={buttonVariant}
      size="lg"
      onClick={buttonAction}
      disabled={disableButton}
    >
      {ButtonIcon && <ButtonIcon className="mr-2 h-5 w-5" />}
      {buttonText}
    </Button>
  );
};

export default PlanActionButton;
